var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVidaslogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    width: "80px",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 737.74 737.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke : black; stroke-width : 5px; fill:white;}.cls-2{fill:black;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "VIdasLogo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ways"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Way",
    className: "cls-1",
    d: "M56.69,226.77S492.32,414.43,737,566.93V455S505.51,350.1,56.69,226.77Z",
    transform: "translate(-56.69 -56.77)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Way_Center_Line",
    "data-name": "Way Center Line"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M737,505.85v7.84c-16-8.85-33.08-17.86-51-27l2.25-5.92C720.75,496.88,737,505.85,737,505.85Z",
    transform: "translate(-56.69 -56.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M619.38,447.88l-2.36,5.2c-20.15-9.48-40.91-19-62-28.4l2-5Q591.5,434.92,619.38,447.88Z",
    transform: "translate(-56.69 -56.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M490.58,390.89l-2.22,4.64c-18.89-8.1-37.86-16.1-56.74-23.95l2.25-4.35Q463.69,379.47,490.58,390.89Z",
    transform: "translate(-56.69 -56.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M391.57,350.09l-2.13,4.12q-22.17-9-43.86-17.72l1.75-3.9Q370.12,341.5,391.57,350.09Z",
    transform: "translate(-56.69 -56.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M314.23,319.76l-1.31,3.74q-13.16-5.22-26-10.22l1.71-3.29Q301.64,314.91,314.23,319.76Z",
    transform: "translate(-56.69 -56.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M268.08,302.22l-1.48,3.11-19.8-7.67,1.68-2.76Q258.38,298.58,268.08,302.22Z",
    transform: "translate(-56.69 -56.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.1,288.1l-1.32,2.64q-8-3.09-15.79-6.05l1.22-2.43Z",
    transform: "translate(-56.69 -56.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M197.38,276.14l-1.19,2.16-13.22-5,1-2Z",
    transform: "translate(-56.69 -56.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M174.38,267.84l-.9,1.89-10.54-4,.83-1.73Z",
    transform: "translate(-56.69 -56.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M155.65,261.15l-.76,1.61-7.64-2.86.6-1.52Z",
    transform: "translate(-56.69 -56.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.07,255.28l-.57,1.37-5.19-1.93.48-1.3Z",
    transform: "translate(-56.69 -56.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128.8,251.66l-.59,1.17-4.11-1.52.61-1.08Z",
    transform: "translate(-56.69 -56.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M120.1,248.62l-.46,1L114,247.59l.54-.91Z",
    transform: "translate(-56.69 -56.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111,245.42l-.39.9C83.3,236.3,65,229.73,58.91,227.54Q85.45,236.56,111,245.42Z",
    transform: "translate(-56.69 -56.77)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Big_V",
    "data-name": "Big V"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M610.2,500C547.93,649.78,493.46,780.8,491.82,784.76a14.49,14.49,0,0,1-13.32,9H381.35c-9.4,0-13-8.32-13-8.32L148.94,271.63c41.76,19,90.5,41.55,142.84,66.47L415.47,625.2s3.23,9.56,13.52,9.56,13.47-9.41,13.47-9.41l73.69-175.79C548,466.18,579.58,483.05,610.2,500Z",
    transform: "translate(-56.69 -56.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268.87,284.92q-61.35-18.89-131-39.13l-8.12-19a14.4,14.4,0,0,0-13.15-9.05H257.21c-9.9,0-13.36,9.12-13.36,9.12Z",
    transform: "translate(-56.69 -56.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M794.43,56.77,646,413.75c-27-10.43-60.11-22.83-99.4-36.9,24.07-57.43,47.21-112.6,62.92-150.08C657.93,111.38,794.43,56.77,794.43,56.77Z",
    transform: "translate(-56.69 -56.77)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Small_V",
    "data-name": "Small V"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M373.56,318q-32.07-10.39-67-21.37h0L240.87,138.68c1.07.42,69.3,28.1,93.6,86.07C344,247.47,358.9,283,373.56,318Z",
    transform: "translate(-56.69 -56.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M487.73,434.84l-31.1,72.83a7.43,7.43,0,0,1-6.59,4.22h-49.2a7.34,7.34,0,0,1-6.74-4.57L331.71,357.24c24,11.58,48.53,23.57,73.33,35.86h0l14,33.48a7.32,7.32,0,0,0,6.82,4.77,7.41,7.41,0,0,0,6.85-4.84l6.94-16.11Q463.69,422.48,487.73,434.84Z",
    transform: "translate(-56.69 -56.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M584.09,220.17a7.29,7.29,0,0,0-6.66,4.58c-1,2.39-30.74,72-60.45,141.58q-24-8.43-50.73-17.55l53.42-124a7.47,7.47,0,0,0-6.77-4.62Z",
    transform: "translate(-56.69 -56.77)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVidaslogo);
export default __webpack_public_path__ + "static/media/vidaslogo.6c0357327a4e12ed2d987da3b6e23fdc.svg";
export { ForwardRef as ReactComponent };